// import { useShepherd } from 'vue-shepherd';
// import VueShepherd from 'vue-shepherd/dist/vue-shepherd.ssr.js';
// import 'shepherd.js/dist/css/shepherd.css';

export default defineNuxtPlugin((nuxtApp) => {
  // if (typeof window !== 'undefined') {
  //   nuxtApp.tour = useShepherd({
  //     useModalOverlay: true,
  //   });
  // }
  // nuxtApp.vueApp.use(VueShepherd);
  // return {
  //   provide: {
  //     tour: VueShepherd,
  //   },
  // };
});
